import { logEvent } from "@/service/logs/log";
import { createPath } from "@/service/routing/routing";
import { useContext } from "react";
import { ResourceContext } from "@/contexts/resource-context";
import { CardTools } from "@/components/common/card-tools/card-tools";

export const Icd10CalculatorCard = ({
  calculator,
  code,
}: {
  calculator: CalculatorPreviewVM;
  code: string;
}) => {
  const { logView } = useContext(ResourceContext);

  return (
    <CardTools
      id={calculator.id}
      title={calculator.title}
      subtitle={calculator.subtitle}
      link={createPath("calculator.show", {
        categorySlug: calculator.category.slug,
        slug: calculator.slug,
      })}
      categoryLink={createPath("calculator.category", {
        slug: calculator.category.slug,
      })}
      categoryName={calculator.category.name}
      categorySvgContent={calculator.category?.iconSvgContent || ""}
      onClick={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("calculator.show", {
            categorySlug: calculator.category.slug,
            slug: calculator.slug,
          }),
          resource_type: "calculator",
        });
      }}
      onClickCategory={() => {
        logEvent("icd10_internal_link_click", logView, {
          icd_code: code,
          resource_path: createPath("calculator.category", {
            slug: calculator.category.slug,
          }),
          resource_type: "calculator_category",
        });
      }}
    />
  );
};
